import { render, staticRenderFns } from "./menuNum.vue?vue&type=template&id=22fc5dc2&scoped=true"
import script from "./menuNum.vue?vue&type=script&lang=js"
export * from "./menuNum.vue?vue&type=script&lang=js"
import style0 from "./menuNum.vue?vue&type=style&index=0&id=22fc5dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fc5dc2",
  null
  
)

export default component.exports